<div class="maintenance container">
    <div class="maintenance--header">
        <img src="assets/images/logo-sc-azul.svg" alt="" class="maintenance--header--logo">
        <div class="maintenance--header--help">
            <a id="ayuda" [routerLink]="['/faq']"><span class="icon-question-elipse"></span> Ayuda</a>
        </div>
    </div>
    <div class="maintenance--body">
        <div class="row">
            <div class="col-md-6 col-xs-12">
                <h1 class="maintenance--body--title">Estamos realizando mejoras sobre la plataforma</h1>
                <h3 class="maintenance--body--subtitle">Por favor, regresá más tarde.<br>Gracias por tu paciencia.</h3>
            </div>
            <div class="col-md-6 col-xs-12">
                <img class="maintenance--body--image" src="assets/images/maintenance-body.png">
            </div>
        </div>
    </div>
    <div class="maintenance--footer">
        <div class="row maintenance--footer--message">
            <div class="col-md-12 col-xs-12">
                <p class="maintenance--footer--message--text">Para realizar operaciones te pedimos que por el momento lo hagas comunicandote con tu sucursal durante el <a href="https://www.sancristobal.com.ar/sucursales/">horario de atención</a></p>
            </div>
        </div>
    </div>
    <img src="assets/images/maintenance-footer.png" alt="" class="maintenance--background">
</div>